import formValidate from '../form/';
import bindEvent from '../../scripts/util/event/bindEvent';
import isElement from '../../scripts/util/DOM/isElement';
import checkKey from '../../scripts/util/event/checkKey';

const selectors = {
	el: '.js-popup',
	image: '.js-popup-image',
	open: '.js-popup-open',
	close: '.js-popup-close'
};

const states = {
	popup: {
		open: 'popup_open'
	},
	image: {
		move: 'popup__image_move'
	}
};

const open = e => {
	const target = e.currentTarget;
	const body = document.querySelector('body');
	const type = target.dataset.popup;
	const popup = document.querySelector(`${selectors.el}[data-type="${type}"]`);
	if (popup) {
		const img = popup.querySelector(selectors.image);
		popup.classList.add(states.popup.open);
		setTimeout(() => img.classList.add(states.image.move), 20);
		body.style.overflow = 'hidden';
	}
};

const close = () => {
	const body = document.querySelector('body');
	const popup = document.querySelector(`.${states.popup.open}`);
	const img = popup.querySelector(selectors.image);
	popup.classList.remove(states.popup.open);
	img.classList.remove(states.image.move);
	body.style.overflow = '';
};

const onKeyPress = e => {
	if (isElement(`.${states.popup.open}`) && checkKey(e)) {
		close();
	}
};

const setHandlers = () => {
	bindEvent(selectors.open, 'click', open);
	bindEvent(selectors.close, 'click', close);
	document.addEventListener('keydown', onKeyPress);
};

const render = () => {
	if (isElement(selectors.el)) {
		setHandlers();
		formValidate();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/popup/index.js